import { getAllStatistics, getAllStatisticsMulti } from './sessions';

const BASE_URL = process.env.API_URL;
const API_VERSION = process.env.API_VERSION;
const API_KEY = process.env['API_KEY'] || '';

type ApiMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export async function apiRequest<T>(
  method: ApiMethod,
  endpoint: string,
  body?: unknown,
  options?: RequestInit
): Promise<T> {
  const token = localStorage.getItem('authToken');

  const res = await fetch(`${BASE_URL}/${API_VERSION}${endpoint}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'x-api-key': API_KEY,
      ...(options?.headers || {}),
      'Authorization': token ? `Bearer ${token}` : ''
    },
    body: body ? JSON.stringify(body) : undefined,
    ...options,
  });

  // 401 Unauthorized
  if (res.status === 401) {
    window.dispatchEvent(new Event("logout"));
    return undefined as T;
  }

  // optional for DELETE/204 responses
  if (res.status === 204) {
    return undefined as T;
  }

  if (!res.ok) {
    return undefined as T;
  }

  return res.json();
}


// Interface describing browser available debug methods in development mode
declare global {
  interface Window {
    // Devices
    getDevices: () => void;
    getDevice: (id: any) => void;
    createDevice: (data: any) => void;
    updateDevice: (id: any, data: any) => void;
    registerDeviceWithCode: (data: any) => void;
    requestRegistrationCode: (id: any) => void;
    unregisterDevice: (id: any) => void;
    deleteDevice: (id: any) => void;

    // Leaderboards
    getLeaderboards: () => void;
    getLeaderboard: (id: any) => void;
    getLeaderboardEntries: (id: any) => void;
    createLeaderboard: (data: any) => void;
    updateLeaderboard: (id:string, data: any) => void;
    submitLeaderboardEntry: (id: any, data: any) => void;
    deleteLeaderboard: (id: any) => void;

    // Leagues
    getLeagues: () => void;
    getLeague: (id: any) => void;
    createLeague: (data: any) => void;
    deleteLeague: (id: any) => void;

    // Protocols
    getProtocols: () => void;
    getTemplateProtocols: () => void;
    getProtocol: (id: any) => void;
    createProtocol: (data: any) => void;
    updateProtocol: (id: string, data: any) => void;
    deleteProtocol: (id: string) => void;

    // Sessions
    getSessions: () => void;
    getSession: (id: string) => void;
    createSession: (data: any) => void;
    updateSession: (id: string, data: any) => void;
    getSessionsForUser: (userId: string) => void;
    getActivityStatisticsForUser: (userId: string, activityName: string) => void;
    getAllStatistics: (query: string) => void;
    getAllStatisticsMulti: (queries: string[]) => void;

    // Users
    getUsers: () => void;
    getUser: (id: string) => void;
    createUser: (data: any) => void;
    updateUser: (id: string, data: any) => void;
    updateUserProtocol: (id: string, data: any) => void;
    deleteUser: (id: string) => void;
  }
}
